export default __webpack_public_path__ + "static/Anklogo-da4e29004da3a5039a41470cd95549bc.svg";